import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { tokens } from '../../theme/tokens';

/**
 * Empty state for list pages.
 * Shows a friendly message and optional primary action when there's no data.
 */
export default function EmptyState({
  icon: Icon = InboxIcon,
  title = 'No data yet',
  description = 'Get started by adding your first item.',
  actionLabel,
  onAction,
  children,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 5.5,
        textAlign: 'center',
        border: `1px solid ${tokens.border}`,
        boxShadow: tokens.shadow,
        borderRadius: tokens.radius,
        bgcolor: tokens.surface,
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: '12px',
          bgcolor: tokens.bg,
          color: tokens.muted,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 1.5,
        }}
      >
        <Icon sx={{ fontSize: 22 }} />
      </Box>
      <Typography sx={{ fontWeight: 600, color: tokens.ink, fontSize: 15, mb: 0.5 }}>
        {title}
      </Typography>
      <Typography sx={{ color: tokens.muted, fontSize: 13.5, mb: 2, maxWidth: 360, mx: 'auto', lineHeight: 1.5 }}>
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Button
          variant="contained"
          onClick={onAction}
          sx={{ mt: 0.5, bgcolor: tokens.primary, '&:hover': { bgcolor: tokens.primaryStrong } }}
        >
          {actionLabel}
        </Button>
      )}
      {children}
    </Paper>
  );
}
